<template>
  <div class="group-detail">
    <h1 class="common__main-title">Student Import</h1>
    <div class="common__sub-title">Import</div>
    <div class="content-wrapper">
      <div class="main-content">
        <div class="main-content__csv-box">
          <p>Student csv</p>
          <FileInput v-model="selectedCsv" ref="csv" />
          <div class="error-text"
              v-for="message of errorMessages"
              :key="message">
            {{ message }}
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <b-button
          pill
          variant="primary"
          @click="confirmUploadCsv"
        >
          Import
        </b-button>
      </div>
    </div>
    <ConfirmModal ref="confirmModal" isLoadingMode @ok="registerStudents" />
    <SuccessModal ref="sucessModal" />
  </div>
</template>

<script>
import _ from 'lodash';
import FileInput from '@/components/parts/inputItem/FileInput.vue';
import ConfirmModal from '@/components/parts/modal/Confirm.vue';
import SuccessModal from '@/components/parts/modal/Success.vue';

export default {
  components: {
    FileInput,
    ConfirmModal,
    SuccessModal,
  },

  data: () => ({
    selectedCsv: null,
    errorMessages: [],
  }),

  methods: {
    /**
     * CSVアップロード確認
     */
    confirmUploadCsv() {
      if (!this.selectedCsv) {
        this.errorMessages = ['required csv file.'];
        return;
      }
      this.errorMessages = [];

      // 登録数チェック
      const reader = new FileReader();
      reader.onerror = (e) => {
        this.errorMessages = ['selected file has error. please select file again.']
        this.selectedCsv = null
      }
      reader.onload = () => {
        // ヘッダの一行は除いてインポート人数の確認モーダルを表示
        const recordsCount = _.chain(reader)
          .get('result')
          .split('\n')
          .drop()
          .compact()
          .value()
          .length

        this.$refs.confirmModal.open(`Import ${recordsCount} students. Is it OK?`);
      };
      reader.readAsText(this.selectedCsv);
    },
    /**
     * 履修者一括登録
     */
    registerStudents() {
      this.$store.dispatch('importStudentsByCsv', this.selectedCsv)
        .then(() => {
          this.$refs.confirmModal.close();
          this.$refs.sucessModal.open();
        })
        .catch((error) => {
          if (!_.get(error, 'response')) {
            this.errorMessages = [error];
            return this.$refs.confirmModal.close()
          }

          const responseMessage = _.get(error, 'response.data.message')
          if (_.isArray(responseMessage)) {
            this.errorMessages = _.map(responseMessage, ({ index, message }) => `row ${index} student has error: ${message}`)
          } else {
            this.errorMessages = [responseMessage]
          }

          return this.$refs.confirmModal.close();
        });
    },
  },
};

</script>

<style scoped>
.main-content {
  padding: 20px;
  border-radius: 20px;
  margin-bottom:20px;
}

.content-wrapper {
  background: #D8D8D8;
  padding: 20px 50px;
  min-height: 700px;
}

.main-content p {
  display: block;
  text-align: left;
  margin:10px 0;
  font-weight: bold;
  text-align: left;
  margin:10px 0;
  font-weight: bold;
}

.main-content__csv-box {
  margin-bottom:70px;
}

</style>
